import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Checkbox, MenuItem, Row, Select, Tooltip, Typography } from 'seagull';
import { QuestionCircle } from 'seagull/icons/essentials';
import { LegalTermsDropdown } from '~/components/LegalTermsDropdown/LegalTermsDropdown';
import styles from '../AdHocBillModal.module.scss';
import { NetTermsOption } from '../AdHocBillModal.types';
import { selectOptionTestId } from './PaymentSettingsSection.utils';
export const PaymentSettingsSection = (param)=>{
    let { testIds, showTermsOfService, texts } = param;
    const { control, clearErrors, getValues, trigger } = useFormContext();
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.section,
        testId: testIds.Section(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                weight: "normal",
                className: styles.sectionTitle,
                children: texts.sectionTitle()
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "coverCreditCardFees",
                render: (renderProps)=>/*#__PURE__*/ _jsxs(Select, {
                        bi: {
                            name: 'cc_fee_paid_by'
                        },
                        label: texts.ccFeePaidBy.label(),
                        testId: testIds.CcFeePaidBy(),
                        value: renderProps.field.value ? 'vendor' : 'client',
                        onChange: (event)=>renderProps.field.onChange(event.target.value === 'vendor'),
                        children: [
                            /*#__PURE__*/ _jsx(MenuItem, {
                                value: "client",
                                testId: selectOptionTestId(testIds.CcFeePaidBy(), 'client'),
                                children: texts.ccFeePaidBy.theClient()
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                value: "vendor",
                                testId: selectOptionTestId(testIds.CcFeePaidBy(), 'vendor'),
                                children: texts.ccFeePaidBy.theVendor()
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "netTerms",
                render: (renderProps)=>/*#__PURE__*/ _jsxs(Select, {
                        bi: {
                            name: 'net_terms'
                        },
                        label: texts.netTerms.label(),
                        testId: testIds.NetTerms(),
                        value: renderProps.field.value,
                        onChange: (event)=>renderProps.field.onChange(event.target.value),
                        children: [
                            /*#__PURE__*/ _jsx(MenuItem, {
                                value: NetTermsOption.Immediate,
                                testId: selectOptionTestId(testIds.NetTerms(), 'immediate'),
                                children: texts.netTerms.immediate()
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                value: NetTermsOption.Net7,
                                testId: selectOptionTestId(testIds.NetTerms(), 'net7'),
                                children: texts.netTerms.net7()
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                value: NetTermsOption.Net15,
                                testId: selectOptionTestId(testIds.NetTerms(), 'net15'),
                                children: texts.netTerms.net15()
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                value: NetTermsOption.Net30,
                                testId: selectOptionTestId(testIds.NetTerms(), 'net30'),
                                children: texts.netTerms.net30()
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                value: NetTermsOption.Net45,
                                testId: selectOptionTestId(testIds.NetTerms(), 'net45'),
                                children: texts.netTerms.net45()
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                value: NetTermsOption.Net60,
                                testId: selectOptionTestId(testIds.NetTerms(), 'net60'),
                                children: texts.netTerms.net60()
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "includeTermsOfService",
                render: (renderProps)=>/*#__PURE__*/ _jsxs(Row, {
                        gap: 4,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Checkbox, {
                                testId: testIds.IncludeTermsOfService(),
                                checked: renderProps.field.value,
                                onChange: (event)=>{
                                    const checked = event.currentTarget.checked;
                                    renderProps.field.onChange(checked);
                                    if (!checked) clearErrors('termsOfServiceId');
                                },
                                label: texts.includeTermsOfService(),
                                bi: {
                                    name: 'include_terms_of_service'
                                }
                            }),
                            /*#__PURE__*/ _jsx(Tooltip, {
                                title: texts.includeTermsOfServiceTooltip(),
                                placement: "top",
                                children: /*#__PURE__*/ _jsx("span", {
                                    "data-testid": testIds.IncludeTermsOfServiceTooltip(),
                                    className: styles.tooltipIcon,
                                    children: /*#__PURE__*/ _jsx(QuestionCircle, {
                                        size: 16
                                    })
                                })
                            })
                        ]
                    })
            }),
            showTermsOfService && /*#__PURE__*/ _jsx(Box, {
                className: styles.termsOfServiceIndent,
                testId: testIds.TermsOfService(),
                children: /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    name: "termsOfServiceId",
                    rules: {
                        validate: (value)=>!getValues('includeTermsOfService') || !!value || texts.termsOfService.required()
                    },
                    render: (renderProps)=>{
                        var _renderProps_fieldState_error;
                        return /*#__PURE__*/ _jsx(LegalTermsDropdown, {
                            testId: testIds.TermsOfService(),
                            selectedLegalTermId: renderProps.field.value || undefined,
                            onSelectLegalTerm: (legalTerm)=>{
                                var _ref;
                                renderProps.field.onChange((_ref = legalTerm === null || legalTerm === void 0 ? void 0 : legalTerm.id) !== null && _ref !== void 0 ? _ref : '');
                                trigger('termsOfServiceId');
                            },
                            error: (_renderProps_fieldState_error = renderProps.fieldState.error) === null || _renderProps_fieldState_error === void 0 ? void 0 : _renderProps_fieldState_error.message
                        });
                    }
                })
            })
        ]
    });
};
